import AdaptivePopup from '../../../../../../../../components/AdaptivePopup/AdaptivePopup';
import { CrossIcon } from '../../../../../../../../assets/icons/controls/controls';

function BlockFormPopup({
    isOpen,
    onClose,
    selectedTypeMeta,
    SelectedFormComponent,
    selectedBlock,
    onChange,
}) {
    return (
        <AdaptivePopup isOpen={isOpen} handleClose={onClose}>
            <div className='edit-main-page__popup'>
                <div className='edit-main-page__popup-header'>
                    <div className='edit-main-page__popup-title'>
                        {selectedTypeMeta?.title || 'Настройки блока'}
                    </div>
                    <button
                        className='edit-main-page__popup-close'
                        type='button'
                        onClick={onClose}
                    >
                        <CrossIcon
                            mainClassName='edit-main-page__popup-close-icon'
                            strokeClassName='edit-main-page__popup-close-icon-stroke'
                        />
                    </button>
                </div>
                <div className='edit-main-page__popup-body'>
                    {selectedBlock && SelectedFormComponent ?
                        <SelectedFormComponent
                            item={selectedBlock}
                            title={selectedTypeMeta?.title || ''}
                            handleChange={onChange}
                        />
                        : null}
                </div>
            </div>
        </AdaptivePopup>
    );
}

export default BlockFormPopup;
